//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/TaggedObject.js";
import "../AME/AME.SortingBlockBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ResultString",0,0],[1,"SortingBlock",0,"AME.SortingBlockBuilder",0],[1,"TargetObjectSelection",0,"SelectNXObjectList",0]],[[["numConnencedObjects","connencedObjects"],"GetConnectedObjects",{},0,0],[[],"Disconnect",{},0,0],[[],"ConnectFix",{},0,0],[["exp"],"ConnectDynamic",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.AME.ObjectConnectionBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ObjectConnectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.ObjectConnectionBuilder.Type = Object.freeze({
    "Object" : "Object", "Port" : "Port", "Expression" : "Expression"});

export default SPLM;